<template>
  <el-table
    ref="shift"
    border
    stripe
    :data="data"
    :header-cell-style="getCellStyle"
    size="mini"
    highlight-current-row
  >
    <el-table-column
      align="center"
      header-align="center"
      prop="shiftId"
      label="班次"
      width="120px"
    >
      <template slot-scope="{ row }">
        <span v-text="row.shiftName"></span><br />
        <span>({{ row.shiftStart }}-{{ row.shiftEnd }})</span>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      header-align="center"
      v-for="week in weeks"
      :prop="'week' + week.weekNo"
      :label="week.name"
      :key="week.weekNo"
    >
      <template slot-scope="{ row }">
        <el-switch
          v-model="row['week' + week.weekNo].isEnable"
          :disabled="isView"
          active-color="#13ce66"
        >
        </el-switch>
        <br />
        <el-radio-group
          v-if="row['week' + week.weekNo].isEnable"
          size="mini"
          v-model="row['week' + week.weekNo].clinicType"
        >
          <div style="text-align: center; margin: 5px 0">
            <el-radio label=""> 不限 </el-radio>
          </div>
          <div style="text-align: center; margin: 5px 0">
            <el-radio label="outpatient"> 门诊 </el-radio>
          </div>
          <div style="text-align: center; margin: 5px 0">
            <el-radio label="inpatient"> 住院 </el-radio>
          </div>
        </el-radio-group>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Config from "@/config/constant";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      weeks: Config.weeks,
      list: [],
    };
  },
  methods: {
    getCellStyle({ row, column }) {
      let obj = { color: "white" };
      if (!column.property || column.property == "shiftId") {
        obj.backgroundColor = "#1989FA";
      } else {
        obj.backgroundColor = "#409EFF";
      }
      return obj;
    },
  },
};
</script>

<style scoped></style>
